export const VideoType = {
  Subscribed: 'subscribed',
  Star: 'star',
  Free: 'free',
  Brand: 'brand',
  TopTen: 'top_ten',
  Event: 'event_area',
  Featured: 'featured',
  Popular: 'popular',
  GuessYouLike: 'guess-you-like',
  New: 'new',
}

export type VideoTypeType = (typeof VideoType)[keyof typeof VideoType]

export const getSectionTitle = (seriesType: VideoTypeType) => {
  const titleMap: Record<VideoTypeType, string> = {
    [VideoType.Subscribed]: 'page.home.section.title.subscribed',
    [VideoType.Star]: 'page.home.section.title.star',
    [VideoType.Free]: 'page.home.section.title.exclusive',
    [VideoType.Brand]: 'page.home.section.title.campaign',
    [VideoType.TopTen]: 'page.home.section.title.hotCreators',
    [VideoType.Event]: 'page.home.section.title.event',
    [VideoType.Featured]: 'page.home.section.title.featured',
    [VideoType.Popular]: 'page.home.section.title.hotVideos',
    [VideoType.GuessYouLike]: 'page.home.section.title.recommended',
    [VideoType.New]: 'page.home.section.title.newVideos',
  }
  return titleMap[seriesType] || ''
}
